import React from 'react';
import About from '../components/About';
import { useViewTracking } from '../hooks/useViewTracking';

const AboutPage: React.FC = () => {
  useViewTracking({ viewType: 'about' });

  return <About />;
};

export default AboutPage;
